import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';

export interface FooterLink {
  name: string;
  href?: string;
  reference: Reference;
}

export interface Props {
  header?: string;
  links: FooterLink[];
  openInNewTab?: boolean;
  className?: string;
}

const Column: React.FC<Props> = ({ header, links, openInNewTab, className }) => {
    const hasMultiLevelChildLinks = links?.length > 1;
    const linkUrl = links?.[0]?.href ?? "#";
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
      <div className={className}>
        {header && (
          <Link variant="primary" link={linkUrl} target={openInNewTab ? '_blank' : ''} onClick={handleScrollToTop}>
            <Typography className="marign-bottom-0 self-start text-16 font-medium text-neutral-200">
              {header}
            </Typography>
          </Link>
        )}

        {hasMultiLevelChildLinks && (
          <ul role="list" className=" marign-bottom-0 flex flex-col items-start gap-y-18 self-start">
            {links.map((item, i) => (
              <li key={i}>
                <Link variant="primary" link={item.reference}>
                  <Typography as="fragment">{item.name}</Typography>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
};

export default Column;
